import { render } from "./platformTable.vue?vue&type=template&id=3a785648&scoped=true"
import script from "./platformTable.vue?vue&type=script&lang=js"
export * from "./platformTable.vue?vue&type=script&lang=js"

import "./platformTable.vue?vue&type=style&index=0&id=3a785648&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a785648"]])

export default __exports__